<template>
	<div class="d-flex align-center" :style="getContainerStyle()">
		<div
			v-if="menuOpen"
			style="position: fixed;height: 100vh;width:100vw;top:0;left:0;z-index: 8;background-color: rgba(0,0,0,0.2);"
			@click="menuOpen = false"
			></div>
		<v-menu
			v-model="menuOpen"
			bottom
			offset-y
			left
			min-width="600"
			max-width="600"
			:close-on-content-click="false"
			:close-on-click="false"
			@input="changeMenu"
		>
			<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
						<v-btn
							outlined
							dark
							small
							:block="size == 'large'"
							color="#959595"
							v-bind="{ ...tooltipAttrs, ...menuAttrs }"
							v-on="{ ...tooltipOn, ...menuOn }"
						>
							<v-icon dark>mdi-file-document-outline</v-icon>
							<p class="mb-0 ml-1" v-if="($vuetify.breakpoint.width > 1500 && size != 'small') || size == 'large'">Documentos</p>
						</v-btn>
					</template>
					<span>Documentos asociados a la Línea de Proyecto</span>
				</v-tooltip>
			</template>
			<div class="white" style="position: relative;">
				<div class="d-flex justify-space-between grey darken-3 px-4 py-1">
					<p class="mb-0 caption white--text">Documentos Línea Proyecto</p>
					<v-btn
						icon
						dark
						x-small
						color="white"
						@click="changeMenu(false)"
					>
						<v-icon dark>mdi-close</v-icon>
					</v-btn>
				</div>
				<div>
					<v-btn-toggle
						v-model="selectedType"
						dense
						tile
						mandatory
						class="d-flex flex-row custom-toggle-btns"
					>
						<v-btn :value="1" class="flex-grow-1"
							:color="selectedType == 1 ? '#FF120B':''">
							<div>
								<p class="mb-0 caption font-weight-bold" :class="selectedType == 1 ? 'white--text':''">Informes</p>
							</div>
						</v-btn>
						<v-btn :value="2" class="flex-grow-1"
							:color="selectedType == 2 ? '#FF120B':''">
							<div>
								<p class="mb-0 caption font-weight-bold" :class="selectedType == 2 ? 'white--text':''">Presupuestos</p>
							</div>
						</v-btn>
						<v-btn :value="3" class="flex-grow-1"
							:color="selectedType == 3 ? '#FF120B':''">
							<div>
								<p class="mb-0 caption font-weight-bold" :class="selectedType == 3 ? 'white--text':''">Contratos</p>
							</div>
						</v-btn>
						<v-btn :value="4" class="flex-grow-1"
							:color="selectedType == 4 ? '#FF120B':''">
							<div>
								<p class="mb-0 caption font-weight-bold" :class="selectedType == 4 ? 'white--text':''">Anexos</p>
							</div>
						</v-btn>
						<v-btn :value="5" class="flex-grow-1"
							:color="selectedType == 5 ? '#FF120B':''">
							<div>
								<p class="mb-0 caption font-weight-bold" :class="selectedType == 5 ? 'white--text':''">Subcontratos</p>
							</div>
						</v-btn>
					</v-btn-toggle>
					<v-divider class="my-2"></v-divider>
					<div v-if="loading" class="d-flex justify-center align-center" style="height: 200px;">
						<v-progress-circular
							indeterminate
							color="#FF120B"
						></v-progress-circular>
					</div>
					<div v-else-if="documentsFiltered.length === 0" class="d-flex justify-center align-center px-4" style="height: 200px;">
						<div class="text-center">
							<v-icon large color="#CCCCCC" class="mb-2">mdi-file-document-outline</v-icon>
							<p class="mb-0 caption" style="color: #999999;">No hay documentos en esta categoría</p>
						</div>
					</div>
					<v-list v-else class="pt-0" style="max-height: 300px;overflow: scroll;">
						<v-list-item
							v-for="(item, i) in documentsFiltered"
							:key="i"
							class="px-0 py-0"
							@click="openDocument(item)"
						>
							<div style="width: 100%">
								<div class="d-flex flex-row px-4 justify-space-between">
									<div class="px-4 caption">
										<p class="mb-0 caption font-weight-bold" style="color: #707070;">{{typeSelectedText}} - <b>{{ item.project_code }}</b></p>
									</div>
									<div>
									</div>
								</div>
							</div>
						</v-list-item>
					</v-list>
				</div>
			</div>
			<v-divider class="mx-2"></v-divider>
		</v-menu>
	</div>
</template>

<script>
import {getProjectLineDocuments} from '@/helpers/api/projectlines'

export default {
	name: 'ProjectLineDocumentsMenu',
	props: {
		project_line_id: {
			type: Number,
			required: true
		},
		size: {
			type: String,
			default: 'default'
		}
	},
	computed: {
		projectLineDocuments(){
			return this.$store.state.projects.projectLineDocuments
		},
		typeSelectedText(){
			const typeTabMap = {
				1: 'Informe',
				2: 'Presupuesto',
				3: 'Contrato',
				4: 'Anexo',
				5: 'Subcontrato'
			}
			return typeTabMap[this.selectedType]
		},
		typeSelected(){
			const typeTabMap = {
				1: 'reports',
				2: 'budgets',
				3: 'contracts',
				4: 'addendums',
				5: 'subcontracts'
			}
			return typeTabMap[this.selectedType]
		},
		typeToOpen(){
			const typeTabMap = {
				1: 'report',
				2: 'budget',
				3: 'contract',
				4: 'addendum',
				5: 'subcontract'
			}
			return typeTabMap[this.selectedType]
		},
		documentsFiltered() {
			return this.projectLineDocuments[this.typeSelected] || []
		},
	},
	data() {
		return {
			menuOpen: false,
			selectedType: 1,
			loading: true,
			documentWindowOpen: false
		}
	},
	mounted(){
		this.getDocuments()
	},
	methods: {
		getContainerStyle() {
			if (this.documentWindowOpen) {
				return 'width: 70%;'
			}
			return this.size == 'large' ? 'width: 100%;' : ''
		},
		changeMenu(value){
			this.menuOpen = value
		},
		async getDocuments(){
			this.loading = true
			const documents = await getProjectLineDocuments({project_line_id: this.project_line_id})
			if(documents.code === 200){
				this.$store.commit('projects/setProjectLineDocuments', documents.documents)
			}
			this.loading = false
		},
		openDocument(item){
			if(item.pdf?.file){
				const screenWidth = screen.width
				const screenHeight = screen.height
				const currentWindowWidth = Math.round(screenWidth * 0.70)
				const newWindowWidth = Math.round(screenWidth * 0.40)
				const newWindowLeft = screenWidth - newWindowWidth
				
				// Abrir la nueva ventana en el 30% a la derecha primero
				const documentWindow = window.open(
					item.pdf.file.file_link,
					'',
					`width=${newWindowWidth},height=${screenHeight},left=${newWindowLeft},top=0,toolbar=no,menubar=no,location=no,status=no`
				)
				
				// Intentar múltiples veces redimensionar y mover la ventana actual
				let attempts = 0
				const resizeCurrentWindow = setInterval(() => {
					attempts++
					try {
						window.moveTo(0, 0)
						window.resizeTo(currentWindowWidth, screenHeight)
					} catch (e) {
						console.log('No se puede redimensionar ventana')
					}
					
					if (attempts > 5) {
						clearInterval(resizeCurrentWindow)
					}
				}, 100)
				
				this.documentWindowOpen = true
				
				// Detectar cuando la ventana se cierra
				const checkWindowClosed = setInterval(() => {
					if (documentWindow?.closed) {
						this.documentWindowOpen = false
						// Restaurar ventana actual al tamaño original
						try {
							window.resizeTo(screenWidth, screenHeight)
							window.moveTo(0, 0)
						} catch (e) {
							console.log('No se puede restaurar ventana')
						}
						clearInterval(checkWindowClosed)
					}
				}, 500)
			}
		}
	}
}
</script>

<style>

</style>